import { getContentEntries } from './client.js';

/**
 * Fetch all articles for given queryOpts, skipping current slug article.
 */
const fetchContents = async (queryOpts, order = 'asc') => {
  const defaultValue = {
    items: [],
    total: 0
  };
  const entries = await getContentEntries({
    isPreview: queryOpts.isPreview,
    env: queryOpts.env,
    locale: queryOpts.locale,
    tagId: queryOpts.tagId,
    slug: queryOpts.slug,
    queryParams: {
      order: order === 'asc' ? '-fields.publicationDate' : 'fields.publicationDate',
      'fields.content.sys.contentType.sys.id': queryOpts.contentType,
      limit: queryOpts.limit,
      skip: queryOpts.limit
    }
  });
  return entries || defaultValue;
};
export { fetchContents };
//# sourceMappingURL=fetchContents.js.map
